import { wrap as withStyle } from 'utils/styles'

export default withStyle(
  (props) => `
    margin-top: 8px;
    border-radius: 3px;
    padding: 1px;
    border: 1px solid ${props.theme.basicBoxBorderColor};
    overflow-y: auto;
    &:hover {
      border: 1px solid ${props.theme.hoverPrimaryColor};
    }
  `
)
